import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section about">
            <h3 className="footer-title">Holistic Holidays LLP</h3>
            {/* <p>
              Experience authentic Kerala with personalized travel experiences designed for international travelers.
              Our mission is to showcase the beauty, culture, and hospitality of God's Own Country.
            </p> */}
            <div className="contact">
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span>+91 9818043272</span>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span>+91 9818060273</span>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>info@holisticholidays.in</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>Koothattukulam, Ernakulam, Kerala,</span>
              </div>
            </div>
            <div className="socials">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FaFacebook className="social-icon" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FaTwitter className="social-icon" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FaInstagram className="social-icon" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <FaYoutube className="social-icon" />
              </a>
            </div>
          </div>

          <div className="footer-section links">
            <h3 className="footer-title">Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/destinations">Destinations</Link></li>
              <li><Link to="/packages">Packages</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-section destinations">
            <h3 className="footer-title">Popular Destinations</h3>
            <ul>
              <li><Link to="/destinations/alleppey">Alleppey Backwaters</Link></li>
              <li><Link to="/destinations/munnar">Munnar Hills</Link></li>
              <li><Link to="/destinations/fort-kochi">Fort Kochi</Link></li>
              <li><Link to="/destinations/wayanad">Wayanad Wildlife</Link></li>
              <li><Link to="/destinations/kovalam">Kovalam Beach</Link></li>
              <li><Link to="/destinations/thekkady">Thekkady</Link></li>
            </ul>
          </div>

        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Holistic Holidays LLP. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 